/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Bright_Buck_TiltInputs */

const en_fair_bright_buck_tilt = /** @type {(inputs: Fair_Bright_Buck_TiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic personal details about the member. These fields help with identification and personalization throughout the system.`)
};

const de_fair_bright_buck_tilt = /** @type {(inputs: Fair_Bright_Buck_TiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundlegende persönliche Daten über den Benutzer. Diese Felder helfen bei der Identifikation und Personalisierung im gesamten System.`)
};

/**
* | output |
* | --- |
* | "Basic personal details about the member. These fields help with identification and personalization throughout the system." |
*
* @param {Fair_Bright_Buck_TiltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fair_bright_buck_tilt = /** @type {((inputs?: Fair_Bright_Buck_TiltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Bright_Buck_TiltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fair_bright_buck_tilt(inputs)
	return de_fair_bright_buck_tilt(inputs)
});